type SberConfig = {
  key?: string;
  partnerId?: string;
  erid?: string;
  widgetId?: string;
};

type SberWidgetsSDK = {
  create: (options: {
    widgetId?: string;
    key?: string;
    partnerId?: string;
    container: HTMLElement;
    erid?: string;
  }) => void;
};

declare global {
  interface Window {
    SberWidgetsSDK?: SberWidgetsSDK;
  }
}

export function hasSberConfig(config: SberConfig): boolean {
  return Boolean(config.key && config.partnerId && config.erid && config.widgetId);
}

function createSberWidget(container: HTMLElement, config: SberConfig): void {
  if (!window.SberWidgetsSDK || typeof window.SberWidgetsSDK.create !== 'function') {
    return;
  }

  window.SberWidgetsSDK.create({
    widgetId: config.widgetId,
    key: config.key,
    partnerId: config.partnerId,
    container,
    erid: config.erid
  });
}

export function initSberWidget({ delayMs = 0 }: { delayMs?: number } = {}): void {
  const boot = (): void => {
    const container = document.getElementById('sber-widget');
    if (!container) {
      return;
    }

    const config = container.dataset as SberConfig;
    if (!hasSberConfig(config)) {
      return;
    }

    const customContainer = document.querySelector('.custom-sber-container');

    const run = (): void => {
      if (customContainer) {
        customContainer.classList.remove('hidden-widget');
      }
      createSberWidget(container, config);
    };

    if (delayMs > 0) {
      setTimeout(run, delayMs);
      return;
    }

    run();
  };

  // Vite modules are deferred — DOMContentLoaded may already have fired.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}
